export default "__VITE_ASSET__Dmm7yXsE__"